import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    acceptPrompt: "J'accepte les conditions générales de ventes de l'application Activmed",
    confirmConsent: "Accéder à l'application",
    termsPrefix: "Avant de pouvoir continuer sur l'application Activmed, vous devez accepter les conditions générales de ventes de l'application",
    dialogTitle: "Acceptation des conditions générales de vente"
};

export type I18nAcceptTerm = typeof _fr;

const _en: I18nAcceptTerm = {
    acceptPrompt: "I accept the terms of service of the Activmed application",
    confirmConsent: "Go to the application",
    termsPrefix: "Before using the application Activmed, you must accept the terms of service of the application",
    dialogTitle: "Terms of Service of Activmed"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function i18nAcceptTerm(lang?: string): I18nAcceptTerm {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}